import { Empty } from 'antd';
import { EmptyProps } from 'antd/lib/empty';
import { FC } from 'react';

export const ILSEmpty: FC<EmptyProps> = (props) => {
  return <Empty {...props} />;
};
